import React from "react";
import { Provider } from "react-redux";
import { ConnectedRouter } from "connected-react-router";
import { Route, Switch } from "react-router-dom";
import "assets/vendors/style";
import configureStore, { history } from "./appRedux/store";
import App from "./containers/App/index";
import "../src/assets/css/main.css";
import "../src/assets/css/Button.css"
import "../src/assets/css/antd.css"
import "../src/assets/css/Header.css"
import "../src/assets/css/new-style.css";
import "../src/assets/css/global.css"
import "../src/assets/css/meetingRoom.css"

import "../src/assets/css/variable.css"
//const store = configureStore(/* provide initial state if any */);

const NextApp = () => (
  <Provider store={ configureStore }>
    <ConnectedRouter history={ history }>
      <Switch>
        <Route path="/" component={ App } />
      </Switch>
    </ConnectedRouter>
  </Provider>
);

export default NextApp;
